// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export const constants = {
    onePageCheckout: {
        tablet: 1242,
    },
    localStorage: {
        POSTAL_CODE_ID: "postalCodeID",
        POSTAL_CODE: "postalCode",
        SIGNED_OUT: "signedOut",
    },
};

export const checkoutPages = ["OnePageCheckoutPage", "CheckoutShippingPage", "CheckoutReviewAndSubmitPage"];

export const DivWrapper = `div[class^="Wrapper"]`;

export const XNGAGE_ELEMENTS = "Xngage" as any;
